import React from 'react';


import Checkbox from '../../Checkbox/Checkbox';
import FormElement from '../FormElement';

import './FormCheckbox.scss';


function FormCheckbox(props) {

    return (
        <FormElement
            {...props}
            doShowErrorAtLabel={true}
            doShowRequiredBeforeLabel={true}
        >

            <Checkbox {...props}/>

        </FormElement>
    );
}


FormCheckbox.propTypes = {
    ...FormElement.propTypes,
    ...Checkbox.propTypes
};

FormCheckbox.defaultProps = {
    ...FormElement.defaultProps,
    ...Checkbox.defaultProps
};


export default FormCheckbox;
